import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { useSetClinicsObOrderMutation } from "../../../../../api/mutations/useSetClinicsObOrderMutation";

export function useSaveClinicOrder({ onSuccess }) {
  const { tSettings } = useAppTranslation.Settings();

  const { isLoading, mutate } = useSetClinicsObOrderMutation({
    onSuccess: () => {
      uiNotification.success(tSettings("clinics.obOrder.success.update"));
      onSuccess();
    },
    onError: () => {
      uiNotification.error(tSettings("clinics.obOrder.error.update"));
    },
  });

  const save = (orderedClinics) => {
    mutate({
      clinicIds: orderedClinics.map((clinic) => clinic.id),
    });
  };

  return {
    save,
    isSaving: isLoading,
  };
}
